export const portfolioWatchlistTableAsyncModule = {
  importFn: () => import(/* webpackChunkName: "portfolio-watchlist-table" */ './PortfolioWatchlistTable'),
  cacheKey: 'portfolio-watchlist-table',
}
